import React from 'react'
import useTitle from '../hooks/useTitle'

const NotFound: React.FC = () => {
  useTitle("Page Not Found (404) | Speech2")

  return (
    <section className="height-100 bg-gradient-3">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-5 col-md-7">
            <div className="card py-3 shadow-lg">
              <div className="card-body">
                <h1 className="display-3 mb-3 text-center">404</h1>
                <p className="lead">The page you were looking for wasn't found.</p>
                <small>
                  <span>Do you think this might be a mistake?</span>
                  &nbsp;
                  <a href="mailto:hello@speech2.io?subject=File%20Not%20Found">Contact us</a>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NotFound
